import { createSlice } from '@reduxjs/toolkit';

const provisioningSlice = createSlice({
  name: 'provisioning',
  initialState: {
    isActive: false,
    currentStep: null, // 'waiting_payment', 'payment_validated', 'provisioning', 'deploy_system', 'ready'
    numOrder: null,
    serviceName: '',
    serviceType: '', // 'domains', 'orchestrator', 'dbaas', 'cloudVPS', 'dedicatedServer'
    wsConnected: false,
    error: null,
  },
  reducers: {
    startProvisioning: (state, action) => {
      state.isActive = true;
      state.numOrder = action.payload.numOrder;
      state.serviceName = action.payload.serviceName;
      state.serviceType = action.payload.serviceType || '';
      state.currentStep = 'waiting_payment';
      state.error = null;
    },
    setProvisioningStep: (state, action) => {
      state.currentStep = action.payload;
    },
    setWsConnected: (state, action) => {
      state.wsConnected = action.payload;
    },
    setProvisioningError: (state, action) => {
      state.error = action.payload;
    },
    resetProvisioning: (state) => {
      state.isActive = false;
      state.currentStep = null;
      state.numOrder = null;
      state.serviceName = '';
      state.serviceType = '';
      state.wsConnected = false;
      state.error = null;
    },
  },
});

export const {
  startProvisioning,
  setProvisioningStep,
  setWsConnected,
  setProvisioningError,
  resetProvisioning,
} = provisioningSlice.actions;

export default provisioningSlice.reducer;
